import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./styles";
import { NOT_AVAILABLE } from "../../../constants";
// import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

function DownloadField(props) {
  const {
    classes: { question, vehicleDetailsText, cursorPointer, link, downloadMargin },
    label = "",
    value = "",
    url = null,
    onClick = () => {},
  } = props;

  return (
    <Box className={vehicleDetailsText}>
      <Typography variant={"body2"} className={question}>
        {label}
      </Typography>
      <Box className={downloadMargin}>
        <Typography
          variant={"body2"}
          className={url ? `${link} ${cursorPointer}` : ""}
          component="div"
          whitespace="normal"
        >
          {url ? (
            <a
              className={`${link} ${cursorPointer}`}
              download
              style={{ textDecoration: "none" }}
              onClick={() => onClick(url)}
            >
              {value}
            </a>
          ) : (
            NOT_AVAILABLE
          )}
        </Typography>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(DownloadField);
